module.exports = __webpack_public_path__ + "img/HINDU LIME.4d94575.svg";